import { getActiveClient } from 'app/selectors'
import { useSelector } from 'react-redux'
import { isPermitted } from 'utilities'

export const useIsPermitted = (permissionName: string): boolean => {
  const activeClient = useSelector(getActiveClient)

  return permissionName && activeClient && isPermitted(permissionName, activeClient)
}
